<template>
  <div>
    <form
      class="form-container row m-0 d-flex flex-column justify-content-between"
    >
      <div
        class="d-flex flex-column gap-2 justify-content-between content-container"
      >
        <div class="input-container">
          <label for="inputName" class="form-label custom-label m-0"
            >Case Name</label
          >
          <input
            type="text"
            class="custom-input form-control"
            id="inputName"
            autocomplete="off"
            :value="nameSlide"
          />
        </div>

        <div class="input-container">
          <label for="inputDescription" class="form-label custom-label m-0"
            >Case Description</label
          >
          <textarea
            class="custom-input2 form-control"
            id="inputDescription"
            rows="4"
            cols="6"
            placeholder=""
            >{{ descriptionSlide }}</textarea
          >
        </div>
      </div>
    </form>
    <br />
  </div>
  <div class="category-content">
    <div class="category-content-images">
      <p class="uploaded-image-title">Uploaded Images</p>

      <div class="category-content-images-container">
        <div
          v-for="(img, idx) in template.slides[0]['attachments']"
          :key="idx"
          class="position-relative"
        >
          <span
            class="position-absolute maximize-img"
            @click="maximizeImageHandler($event, img.path)"
          >
            <font-awesome-icon :icon="['fas', 'eye']" size="sm" />
          </span>
          <span
            draggable="true"
            @dragstart="dragStartHandler($event, img.id, idx)"
            @touchstart="dragStartHandler($event, img.id, idx)"
            @mouseenter="moveMouseEnterHandelr($event, img.id)"
            @mouseleave="moveMouseLeaveHandelr($event, img.id)"
            @touchmove="touchHandler($event, img.id, idx, true)"
            @touchend="touchHandler($event, img.id, idx, false)"
            class="position-absolute move-img"
            :id="'icon-' + img.id"
          >
            <font-awesome-icon :icon="['fas', 'hand-point-up']" size="sm" />
          </span>
          <div
            class="overlay-img"
            style="display: none"
            :id="'overlay-' + img.id"
          ></div>
          <img
            width="148"
            :id="'img-' + img.id"
            class=""
            height="83"
            :src="s3pathThumb + img.path"
            alt=""
          />
        </div>
      </div>
    </div>
    <div class="category-content-categories">
      <div>
        <div
          class="category-container my-4"
          v-for="(category, catIdx) in template.slides[0]['categories']"
          :key="catIdx"
        >
          <div class="d-flex justify-content-between">
            <div class="show-slide">
              <p class="category-name">{{ category.name }}</p>

              <div class="d-flex justify-content-between">
                <div class="category-slides-container">
                  <div
                    class="position-relative"
                    v-for="(img, imgIdx) in category.slide_categories"
                    :key="imgIdx"
                    draggable="true"
                    @drop="dropHandler($event, category.id, catIdx, imgIdx)"
                    @dragstart="dragStartHandler($event, img.path, idx)"
                    @dragenter.prevent
                    @dragover.prevent
                  >
                    <img
                      class="slide-img"
                      :id="'img-' + category.id + '-' + catIdx + '-' + imgIdx"
                      width="147"
                      height="83"
                      :src="
                        img.path == undefined
                          ? require(`../../../../assets/images/defultSlide.svg`)
                          : img.path === 'defultSlide.svg'
                          ? require(`../../../../assets/images/defultSlide.svg`)
                          : s3pathThumb + img.path
                      "
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <ShowImageModal
    v-if="showImgModal"
    :imagePath="imagePath"
    @close-modal="showImgModal = false"
  />
</template>


<script>
import { defineAsyncComponent } from "vue";

import { logger } from "../../../../helpers/logger";

const ShowImageModal = defineAsyncComponent(() =>
  import("../../../components/ShowImageModal")
);

export default {
  name: "slides-component",
  components: { ShowImageModal },
  data() {
    return {
      s3pathThumb: "https://dk703uarlyapi.cloudfront.net/thumbnail/",
      s3pathImage: "https://dk703uarlyapi.cloudfront.net/images",
      showImgModal: false,
      imagePath: "",
      nameSlide: null,
      descriptionSlide: null,
      isMoving: false,
      id: null,
    };
  },
  async mounted() {
    console.log("answers.slides ", this.template.slides);
    this.nameSlide = this.template.slides[0].name;
    this.descriptionSlide = this.template.slides[0].description;
  },
  props: ["template", "userAnswers"],
  methods: {
    moveMouseEnterHandelr(e, id) {
      logger(["moveMouseEnterHandelr ", id]);
      let img = document.getElementById(`img-${id}`);
      let icon = document.getElementById(`icon-${id}`);
      let overlay = document.getElementById(`overlay-${id}`);

      overlay.style.display = "block";
      icon.style.backgroundColor = "#000";
    },
    moveMouseLeaveHandelr(e, id) {
      logger(["moveMouseLeaveHandelr ", id]);
      let img = document.getElementById(`img-${id}`);
      let icon = document.getElementById(`icon-${id}`);
      let overlay = document.getElementById(`overlay-${id}`);

      overlay.style.display = "none";
      icon.style.backgroundColor = "#00000082";
    },
    touchHandler(e, img, idx, isMoving = false) {
      this.isMoving = isMoving;

      const id = img;

      console.log({ e }, { img });

      const clientX = e.clientX || e.changedTouches[0].clientX;
      const clientY = e.clientY || e.changedTouches[0].clientY;

      if (this.isMoving) {
        console.log("this.isMoving ", this.isMoving);
        console.log({ clientX }, { clientY });
      } else {
        let elmEnd = document.elementFromPoint(clientX, clientY);

        console.log({ elmEnd });
        console.log(elmEnd.id);

        const categoryId = +elmEnd.id.split("-")[1];
        const catIdx = +elmEnd.id.split("-")[2];
        const imgIdx = +elmEnd.id.split("-")[3];

        if (id !== "") {
          const img = this.template.slides[0]["attachments"].filter((item) => {
            if (item?.id === +id) {
              return item?.path;
            }
          });

          const path = img[0]?.path;
          if (path !== null && path !== "") {
            this.template.slides[0].categories[catIdx].slide_categories[
              imgIdx
            ] = {
              id: id,
              path: path,
              order: imgIdx + 1,
            };

            this.userAnswers.slides.forEach((slide, index) => {
              if (
                (slide["category_id"] === categoryId ||
                  slide["cat_index"] === catIdx + 1) &&
                slide["order"] === imgIdx + 1
              ) {
                this.userAnswers.slides.splice(index, 1);
              }
            });

            this.userAnswers.slides.push({
              id: id,
              cat_index: catIdx + 1,
              category_id: categoryId,
              path: path,
              order: imgIdx + 1,
            });
            console.log(this.userAnswers.slides);
            this.template.changeFlag = true;
          }
        }
      }
    },
    dragStartHandler(e, img) {
      const id = img;

      console.log({ img });
      if (img !== "defultSlide.svg") {
        // e.dataTransfer.dropEffect = 'move';
        // e.dataTransfer.effectAllowed = 'move';
        // e.dataTransfer.setData('img', path);
        // e.dataTransfer.setData('id', id);
        this.id = id;
      } else {
        e.dataTransfer.setData("img", null);
      }
    },

    dropHandler(e, categoryId, catIdx, imgIdx) {
      console.log({ e });

      // e.preventDefault();
      // const path = e.dataTransfer.getData('img');
      // const id = e.dataTransfer.getData('id');
      const id = this.id;

      let img = null;

      console.log(
        typeof id === "number",
        { categoryId },
        { catIdx },
        { imgIdx }
      );

      if (typeof id === "number") {
        img = this.template.slides[0]["attachments"].filter((item) => {
          if (item?.id === +id) {
            return item?.path;
          }
        });
      } else {
        img = this.template.slides[0]["attachments"].filter((item) => {
          if (item?.path === id) {
            return item?.path;
          }
        });
      }

      if (id !== "") {
        const path = img[0]?.path;
        console.log({ path }, { img });
        if (path !== null && path !== "" && path !== undefined) {
          this.template.slides[0].categories[catIdx].slide_categories[imgIdx] =
            {
              id: img[0]?.id,
              path: path,
              order: imgIdx + 1,
            };

          this.userAnswers.slides.forEach((slide, index) => {
            if (
              (slide["category_id"] === categoryId ||
                slide["cat_index"] === catIdx + 1) &&
              slide["order"] === imgIdx + 1
            ) {
              this.userAnswers.slides.splice(index, 1);
            }
          });

          this.userAnswers.slides.push({
            id: img[0]?.id,
            cat_index: catIdx + 1,
            category_id: categoryId,
            path: path,
            order: imgIdx + 1,
          });
          console.log(this.userAnswers.slides);
          this.template.changeFlag = true;
        }
      }
    },
    maximizeImageHandler(e, path) {
      this.imagePath = this.s3pathImage + "/" + path;
      this.showImgModal = true;
    },
  },
};
</script>

<style scoped>
.input-container {
  height: 95px;
}

.custom-label {
  font-size: 15px;
  font-weight: 500;
}
.custom-input {
  width: 100%;
  height: 55px;
  font-size: 14px;
  font-weight: 500;
  color: var(--main-color);
  pointer-events: none;
}
.custom-input,
.custom-input:focus,
.custom-input:active {
  background-color: transparent;
  color: var(--main-color);
  border: 1px solid #39525c;
  outline: 0;
  box-shadow: 0 0 0 0;
}

.custom-label {
  font-size: 15px;
  font-weight: 500;
}
.custom-input2 {
  width: 100%;
  font-size: 14px;
  font-weight: 500;
  pointer-events: none;
}
.custom-input2,
.custom-input2:focus,
.custom-input2:active {
  background-color: transparent;
  color: var(--main-color);
  border: 1px solid #39525c;
  outline: 0;
  box-shadow: 0 0 0 0;
}

.move-img {
  left: 56px;
  top: 25px;
  color: #f8f9fa;
  background-color: #00000082;
  width: 30px;
  height: 30px;
  display: flex;
  border-radius: 6px;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  z-index: 1;
}
.move-slide {
  cursor: move;
}
.uploaded-image-title {
  font-family: Poppins, sans-serif;
  font-size: 17px;
}

.category-content {
  display: flex;
  height: 589px;
  border-radius: 11px;
  padding: 27.8px 15px 27.8px 24px;
}

.category-content-images {
  border-right: 1px solid #e65c00;
  width: 200px;
}

.category-content-images-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 180px;
  height: 500px;
  overflow-y: auto;
  overflow-x: hidden;
}

.category-content-categories {
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 16px;
  padding-left: 25px;
  width: 100%;
}

.category-slides-container {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  width: 100%;
  max-height: 200px;
  min-height: 10px;
  overflow-y: auto;
}

.category-name {
  font-family: Poppins, sans-serif;
  font-size: 17px;
  margin-bottom: 10px;
}

.add-slide {
  width: 5%;
}

.show-slide {
  width: 95%;
}

.slide-img {
  margin: 9px 3px 0 0;
  border-radius: 12px;
}

.category-container {
  position: relative;
  border: 1px solid #39525c;
  padding: 12px;
  border-radius: 6px;
}

.maximize-img {
  right: 35px;
  top: 3px;
  color: #f8f9fa;
  background-color: #0000004d;
  width: 20px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.overlay-img {
  background-color: #00000073;
  position: absolute;
  top: 0;
  width: 82.5%;
  height: 100%;
}
</style>